import { nextTick, watch, ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import { login_sign_in_get } from 'server/modules/351.js'
import { portal_login_sign_by_password_get } from 'server/modules/720.js'
import { post } from 'server/axios'

export const loginSignIn = async (params, callback, store) => {
  // 登录
  const result = await login_sign_in_get(params)
  if (result.success && result.data) {
    onLoginSuccess(result.data, store)
  } else {
    callback && callback(result)
  }
}
/**
 * 登录成功的操作
 * @param {*} data
 */
export const onLoginSuccess = (data, store) => {
  console.log(11, JSON.stringify(data))
  localStorage.setItem('userId', data.userId)
  const {
    userId,
    userName,
    token,
    jobNumber,
    email,
    avatar,
    dingTalkUserId
  } = data
  store.commit(
    'user/saveUserInfo',
    {
      id: userId,
      name: userName,
      email,
      jobNumber,
      token,
      avatar,
      dingTalkUserId
    },
    { root: true }
  )
  let backUrl = sessionStorage.getItem('back') || '/'
  if (history.state.back && history.state.back !== history.state.current) {
    backUrl = history.state.back
  }
  location.href = backUrl
}
/**
 * 飞书登录
 * @param {*} state
 */
export const useFeishuLogin = (state, store) => {
  let QRLoginObj = null
  // 飞书二维码扫描
  const fShuLoginQR = () => {
    const REDIRECT_URI = location.origin + '/FeishuLogin'
    const appid = process.env.VUE_APP_FSHU_APPID
    const goto = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${appid}&redirect_uri=${encodeURIComponent(
      REDIRECT_URI
    )}&response_type=code&state=STATE`

    QRLoginObj = window.QRLogin({
      id: 'login_container_feishu',
      goto,
      width: '300',
      height: '300'
    })

    let handleMessage = function(event) {
      const iframe = document.getElementsByTagName('iframe')[0]
      if (QRLoginObj.matchData(event.data)) {
        let loginTmpCode = event.data.tmp_code
        // 在授权页面地址上拼接上参数 tmp_code，并跳转
        window.location.href = `${goto}&tmp_code=${loginTmpCode}`
      }
    }
    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('message', handleMessage, false)
    } else if (typeof window.attachEvent !== 'undefined') {
      window.attachEvent('onmessage', handleMessage)
    }
  }
  /**
   * 飞书免登陆流程
   */
  const feishuRequestAuthCode = async () => {
    const appId = process.env.VUE_APP_FSHU_APPID
    const result = await post(`${process.env.VUE_APP_LOGIN}/login/get/sign`, {
      url: location.origin
    })
    // 通过error接口处理API验证失败后的回调
    window.h5sdk.error(err => {
      throw ('h5sdk error:', JSON.stringify(err))
    })
    // 调用config接口进行鉴权
    window.h5sdk.config({
      appId,
      timestamp: result.timestamp,
      nonceStr: result.noncestr,
      signature: result.signature,
      jsApiList: [],
      //鉴权成功回调
      onSuccess: res => {
        console.log(`config success: ${JSON.stringify(res)}`)
      },
      //鉴权失败回调
      onFail: err => {
        throw `config failed: ${JSON.stringify(err)}`
      }
    })
    window.h5sdk &&
      window.h5sdk.ready(() => {
        // ready 方法不需要每次都调用。
        // eslint-disable-next-line no-undef
        tt.requestAuthCode({
          appId,
          success: info => {
            loginSignIn(
              {
                code: info.code,
                signPlatform: 'feishu'
              },
              () => {
                // eslint-disable-next-line no-undef
                tt.showToast({
                  title: '登录异常，请联系相关人员',
                  icon: 'success',
                  duration: 3000
                })
              },
              store
            )
            // eslint-disable-next-line no-undef
            tt.showToast({
              title: '鉴权成功',
              icon: 'success',
              duration: 3000
            })
          },
          fail: error => {
            console.log(`getAuthCode failed, err:`, JSON.stringify(error))
          }
        })
      })
  }
  watch(
    () => state.activeKey,
    val => {
      nextTick(() => {
        if (val === 3) {
          !QRLoginObj && fShuLoginQR()
        }
      })
    },
    {
      immediate: true
    }
  )
  return {
    feishuRequestAuthCode
  }
}

/**
 * 钉钉扫码登录
 * @param {*} state
 */
export const useDingtalkLogin = (state, store) => {
  /**
   * 钉钉api登录
   */
  const dingTalkLoginQR = function() {
    // appid
    const appid = process.env.VUE_APP_APPID
    // 登录重定向url
    const redirect_uri = process.env.VUE_APP_redirect
    const goto = encodeURIComponent(
      'https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=' +
        appid +
        '&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=' +
        encodeURIComponent(redirect_uri)
    )
    window.DDLogin({
      id: 'login_container',
      goto: goto,
      style: 'border:none;background-color:unset;'
    })
    // 监听钉钉的消息
    /**
     * 钉钉扫码后消息监听
     */
    const handleMessage = async function(event) {
      const iframe = document.getElementsByTagName('iframe')[0]
      if (event.origin === 'https://login.dingtalk.com') {
        iframe.style.opacity = 0
        loginSignIn(
          {
            code: event.data,
            signPlatform: 'dignTalk'
          },
          result => {
            iframe.style.opacity = 1
            message.error(`登录失败：${result.retInfo}`)
            dingTalkLoginQR()
          },
          store
        )
      }
    }

    if (typeof window.addEventListener !== 'undefined') {
      window.addEventListener('message', handleMessage, false)
    } else if (typeof window.attachEvent !== 'undefined') {
      window.attachEvent('onmessage', handleMessage)
    }
  }
  watch(
    () => state.activeKey,
    val => {
      nextTick(() => {
        if (val === 1) {
          dingTalkLoginQR()
        }
      })
    },
    {
      immediate: true
    }
  )
}

export const usePasswordLogin = store => {
  const formRef = ref(null)
  const isFormError = ref(false)
  const errorMsg = ref('')
  const formState = reactive({
    account: null,
    password: null
  })

  const rules = {
    account: {
      required: true,
      message: '请输入账号',
      type: 'string'
    },
    password: {
      required: true,
      message: '请输入密码',
      type: 'string'
    }
  }
  const onSubmit = () => {
    formRef.value
      .validate()
      .then(() => {
        loginByPassword()
      })
      .catch(error => {
        console.log('error', error)
      })
  }
  /**
   * 密码登录
   */
  const loginByPassword = async () => {
    const result = await portal_login_sign_by_password_get(formState)
    if (result.success && result.data) {
      onLoginSuccess(result.data, store)
    } else {
      isFormError.value = true
      errorMsg.value = result.retInfo || '账号密码错误'
    }
  }
  return {
    formState,
    formRef,
    errorMsg,
    isFormError,
    rules,
    onSubmit
  }
}
